import React, { useMemo } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { ConfirmModal } from '~/domains/common/components/Modal/Confirm/ConfirmModal';

import type { ConfirmationModalPayload } from './types';
import { ConfirmationModalType } from './types';

type ConfirmationModalProps = {
  isOpen: boolean;
  payload: ConfirmationModalPayload;
};

function ConfirmationModal({
  isOpen,
  payload: { type, onCancel, onClose, onConfirm, remainingTime, isOnConfirmLoading } = {},
}: ConfirmationModalProps) {
  const { t } = useTranslation('contest');

  const { cancelText, confirmText, description, title } = useMemo(() => {
    switch (type) {
      case ConfirmationModalType.SLIP_CANCELLATION:
        return {
          cancelText: t('quickPick.slipDetail.modal.slipCancellation.cancel'),
          confirmText: t('quickPick.slipDetail.modal.slipCancellation.submit'),
          description: t('quickPick.slipDetail.modal.slipCancellation.description'),
          title: t('quickPick.slipDetail.modal.slipCancellation.title', {
            remainingTime,
          }),
        };
      case ConfirmationModalType.ENTRY_LIMIT_REACHED:
        return {
          cancelText: t('quickPick.board.picksDrawer.errors.entryLimitReached.close'),
          title: t('quickPick.board.picksDrawer.errors.entryLimitReached.title'),
          description: t('quickPick.board.picksDrawer.errors.entryLimitReached.message'),
        };
      default:
        return {};
    }
  }, [t, type, remainingTime]);

  return (
    <ConfirmModal
      cancelText={cancelText}
      confirmText={confirmText}
      description={description}
      isOpen={isOpen}
      onCancel={onCancel || onClose}
      onClose={onClose}
      isOnConfirmLoading={isOnConfirmLoading}
      onConfirm={onConfirm}
      title={title}
    />
  );
}

export default ConfirmationModal;
